import CrownForm from "./CrownForm";
import Tracking from "./Tracking";

jQuery.noConflict();
(function ($) {
  /**
   * Fixed header
   **/
  const formContainer = document.querySelector("aside.sidebar");

  if (formContainer && formContainer.querySelector("form")) {
    var formBounds = formContainer.getBoundingClientRect();

    window.addEventListener("resize", function () {
      formBounds = formContainer.getBoundingClientRect();
    });

    setInterval(() => {
      formBounds = formContainer.getBoundingClientRect();
    }, 1000);

    document.addEventListener("scroll", function (e) {
      var scrTop = window.pageYOffset;

      if (scrTop >= formBounds.top) {
        formContainer.style.setProperty(
          "--nfx",
          parseInt(formBounds.left) + "px"
        );
        formContainer.style.setProperty("--nfy", "135px");
        formContainer.classList.add("news__form");
      } else {
        formContainer.classList.remove("news__form");
      }
    });

    let breakArea = document.querySelector("main .cta");
    let breakPos = breakArea ? breakArea.clientHeight + 35 : 35;
    let breakOpts = { threshold: 0.65 };

    if (!breakArea) {
      breakArea = document.querySelector("footer");
      breakOpts = { threshold: 0 };
    }

    if (breakArea) {
      new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          formContainer.style.setProperty("--nfb", breakPos + "px");
          formContainer.classList.add("news__form--bottom");
          formContainer.classList.remove("news__form");
        } else {
          formContainer.classList.remove("news__form--bottom");
        }
      }, breakOpts).observe(breakArea);
    }
  }

  $(function () {
    var headerHeight;
    function scrollAnchor() {
      headerHeight = $(".header").outerHeight();
    }

    function stickHeader() {
      if ($(window).scrollTop() > headerHeight + 200) {
        $(".docked-header").addClass("docked-header--show");
      } else {
        /* Un-dock header*/
        $(".docked-header").removeClass("docked-header--show");

        /* Reset mobile nav if it was opened (desktop) */
        if (window.matchMedia("only screen and (min-width: 960px)")) {
          $(".nav-mobile").removeClass("header__nav--open");
          $(".page-container").removeClass("header__nav--open");
        }
      }
    }

    /* Update anchor */
    $(document).ready(scrollAnchor);
    $(window).resize(scrollAnchor);

    /* Fixed header */
    $(document).ready(stickHeader);
    $(window).scroll(stickHeader);
  });

  /**
   * Mobile nav
   **/
  (function () {
    var menu = $(".nav-mobile");
    var menuBtn = $(".header__nav__toggle");
    var menuWidth = menu.width() + "px";
    var container = $(".page-container");

    // debounce to avoid double tap
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this;
        var args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    }

    // set up animation action
    var animateNav = debounce(
      function (e) {
        e.stopPropagation();
        e.preventDefault();
        toggleNav();
      },
      200,
      true
    );

    function toggleNav() {
      menu.toggleClass("header__nav--open");
      container.toggleClass("header__nav--open");
    }

    // hook up action
    menuBtn.on("touchend click", animateNav);

    // reset mobile menu if window is resized past breakpoint
    $(window).resize(function () {
      if (window.matchMedia("only screen and (min-width: 960px)")) {
        menu.removeClass("header__nav--open");
        container.removeClass("header__nav--open");
      }
    });
  })();

  /**
   * Sliders
   */
  $(".hero__image").flexslider({
    selector: ".hero__image__list > .hero__image__list__item",
    slideshowSpeed: 6000,
    directionNav: false,
    controlNav: false,
    start: function (slider) {
      startSlider(slider);
    },
    before: function (slider) {
      beforeSlider(slider);
    },
  });

  $(".flexslider").each(function (i) {
    var controls = $(this).find(".flex-control-nav");
    $(this).flexslider({
      manualControls: $(controls).find("li"),
      directionNav: false,
      start: function (slider) {
        startSlider(slider);
        $(controls).addClass("flex-control-paging--loaded");
      },
      before: function (slider) {
        beforeSlider(slider);
      },
    });
  });

  function startSlider(slider) {
    // Fires when the slider loads the first slide
    var slides = slider.slides,
      index = slider.animatingTo,
      currentSlide = index,
      nextSlide = currentSlide + 1;

    $(slider)
      .find("li:eq(" + nextSlide + ") img[data-src]")
      .each(function () {
        var src = $(this).attr("data-src");
        $(this).attr("src", src).removeAttr("data-src");
      });
  }

  function beforeSlider(slider) {
    // Fires asynchronously with each slider animation
    var slides = slider.slides,
      index = slider.animatingTo,
      $slide = $(slides[index]),
      currentSlide = index,
      nextSlide = currentSlide + 1,
      prevSlide = currentSlide - 1;

    $slide
      .parent()
      .find(
        "li:eq(" +
          currentSlide +
          ") img[data-src], li:eq(" +
          nextSlide +
          ") img[data-src]"
      )
      .each(function () {
        var src = $(this).attr("data-src");
        $(this).attr("src", src).removeAttr("data-src");
      });
  }

  $(".suppliers").flexslider({
    selector: ".suppliers__slider > .suppliers__list",
    slideshowSpeed: 2500,
    directionNav: false,
    controlNav: false,
    animation: "slide",
    start: function (slider) {
      var slides = slider.slides,
        index = slider.animatingTo,
        currentSlide = index,
        nextSlide = currentSlide + 1;

      $(slider)
        .find("ul:eq(" + nextSlide + ") img[data-src]")
        .each(function () {
          var src = $(this).attr("data-src");
          $(this).attr("src", src).removeAttr("data-src");
        });
    },
    before: function (slider) {
      var slides = slider.slides,
        index = slider.animatingTo,
        $slide = $(slides[index]),
        currentSlide = index,
        nextSlide = currentSlide + 1,
        prevSlide = currentSlide - 1;

      $slide
        .parent()
        .find(
          "ul:eq(" +
            currentSlide +
            ") img[data-src], ul:eq(" +
            nextSlide +
            ") img[data-src]"
        )
        .each(function () {
          var src = $(this).attr("data-src");
          $(this).attr("src", src).removeAttr("data-src");
        });
    },
  });

  /**
   * Quote page toggle
   */
  $(function () {
    $("[data-tab]").on("click touchdown", function (e) {
      e.preventDefault();
      var tab = $(this).attr("href");

      $(".page-quote__content--active").removeClass(
        "page-quote__content--active"
      );
      $(tab).addClass("page-quote__content--active");

      $(".page-quote__cta__button--active").removeClass(
        "page-quote__cta__button--active"
      );
      $(this).addClass("page-quote__cta__button--active");
    });
  });
})(jQuery);

const consentEvt = (e) => {
  const acceptedCategories = e.detail || {};

  if (acceptedCategories?.performance) {
    const tracking = new Tracking();
    tracking.init();
  } else {
    Tracking.clear();
  }
};

window.addEventListener("cf_consent", consentEvt);
window.addEventListener("cf_consent_loaded", consentEvt);

new CrownForm({
  el: document.querySelector("#quote"),

  url: "/wp-content/themes/exchangeutility/ajax/QuoteForm.php",

  success() {
    window.location.href = "/thanks/";
  },
});
